import React from "react";
import { Row } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ITeamMemberData } from "../../types/api/aboutApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { ITeamMembers } from "../../types/features/multiLanguageSlice";

const AboutTeam: React.FC<{ teamMembers: Array<ITeamMemberData> }> = ({ teamMembers }) => {
    const {t} = useTranslation()
const team_json = t('about_us.teamMembers', { returnObjects: true })  as ITeamMembers[];

    const teamSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 300,
        margin: '10px',
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            }
        ]
    };
    return (
        <div>
            <div>
                <section className='about-team'>
                    <div className="container">
                        <div className="team-heading">
                            <h3 className="title">{t('about_us.team_member')}</h3>
                            <p>{t('about_us.team_description')}</p>
                        </div>
                        <Row>
                            <Slider {...teamSlider}>
                                {
                                    teamMembers && teamMembers.length ?
                                        teamMembers.map((teamMember: ITeamMemberData, index: number) => (
                                            <div className="team-card" key={"Team_member_" + index}>
                                                <img src={teamMember.image} alt="team-img" />
                                                <div className="team-content">
                                                    <h4>{team_json && team_json.length>0 && team_json[index].name}</h4>
                                                    <p>{team_json && team_json.length>0 && team_json[index].role}</p>
                                                </div>
                                            </div>
                                        ))
                                        : <NoData message="Oopsm No Statistics Data Found!!" />
                                }

                            </Slider>
                        </Row>
                    </div>
                </section>
            </div>

        </div>
    )
}
export default AboutTeam;